import {cashBoxViewPage} from "../../../hoc/cashBoxViewPage";

const CashBox = cashBoxViewPage('CashBox')
export default CashBox
